import { Controller } from "@hotwired/stimulus"

// Manages the dynamic invoice items table:
//   - "Add item" clones the <template> row, giving it a unique field index
//   - "Remove" deletes a brand-new row, or flags a persisted row with _destroy
//   - any quantity/price change recomputes that row's amount (quantity * price)
//     and the invoice total at the bottom of the form
//
// The amount inputs are disabled (display-only); the server recomputes amount
// and total_amount on save, so these values are never trusted from the client.
export default class extends Controller {
  static targets = ["items", "template", "total", "row"]

  connect() {
    this.recalculate()
  }

  addItem(event) {
    event.preventDefault()
    // The markup comes from our own server-rendered <template> (Rails fields_for);
    // the only substitution is a numeric timestamp, so there is no user input to inject.
    const html = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime().toString())
    this.itemsTarget.insertAdjacentHTML("beforeend", html)
    this.recalculate()
  }

  removeItem(event) {
    event.preventDefault()
    const row = event.target.closest("[data-invoice-form-target='row']")
    const idField = row.querySelector("input[name$='[id]']")

    if (idField && idField.value) {
      row.querySelector("input[name$='[_destroy]']").value = "1"
      row.classList.add("d-none")
    } else {
      row.remove()
    }

    this.recalculate()
  }

  recalculate() {
    let total = 0

    this.rowTargets.forEach((row) => {
      // A row is excluded once flagged for removal — "1" when removed in this session,
      // "true" when re-rendered by the server after an invalid submit.
      const destroyField = row.querySelector("input[name$='[_destroy]']")
      if (destroyField && (destroyField.value === "1" || destroyField.value === "true")) return

      const quantity = parseFloat(row.querySelector("input[name$='[quantity]']").value) || 0
      const price = parseFloat(row.querySelector("input[name$='[price]']").value) || 0
      const amount = quantity * price

      row.querySelector("input[name$='[amount]']").value = amount.toFixed(2)
      total += amount
    })

    this.totalTarget.textContent = total.toFixed(2)
  }
}
